import { Alert, Flex, Typography } from "antd"
import React from "react"

interface LeadWizardMatchPanelProps {
  title: string
  description: string
  children: React.ReactNode
  more?: React.ReactNode
  footer?: React.ReactNode
}

/**
 * The shell both duplicate panels wear, so two warnings that stack on one screen
 * cannot drift apart.
 *
 * `footer` is optional deliberately: the lead panel offers its way out on every
 * row and must not grow a second one at the bottom.
 */
export function LeadWizardMatchPanel({
  title,
  description,
  children,
  more,
  footer
}: LeadWizardMatchPanelProps) {
  return (
    <Alert
      type={"warning"}
      showIcon
      className={"mb-4"}
      message={title}
      description={
        <Flex vertical gap={"small"}>
          <Typography.Text type={"secondary"}>{description}</Typography.Text>

          <Flex
            vertical
            gap={"small"}
            className={"max-h-72 overflow-y-auto pr-1"}
          >
            {children}
          </Flex>

          {more && (
            <Typography.Text type={"secondary"} className={"text-xs"}>
              {more}
            </Typography.Text>
          )}

          {footer && <Flex justify={"end"}>{footer}</Flex>}
        </Flex>
      }
    />
  )
}
